import React, { useEffect } from 'react'
import './styles.scss'
import Message from '../Message'
// import { useSelector } from 'react-redux'
import { getFormatedDate } from 'utils'
import { getStaticImage } from 'utils/statics'
import { apiInchat } from 'api'
import { toastMessage } from 'utils/messages'
import { useDispatch, useSelector } from 'react-redux'
import inchatActions from 'redux/inchat/actions'
import { lang } from 'utils/helpers'

const PinnedMessages = ({ conversationId }) => {
  const [isOpenMessages, setIsOpenMessages] = React.useState(false)
  const [countMessages, setCountMessages] = React.useState('')
  const onToggleIsOpenMessages = () => setIsOpenMessages(!isOpenMessages)
  const dispatch = useDispatch()
  const { inchat } = useSelector(store => store)
  const pinned = inchat.pinned[conversationId] || {}
  const messages = pinned?.messages || []
  const total = pinned?.total || 0

  useEffect(() => {
    getPinnedMessages()
  }, [])

  useEffect(() => {
    isOpenMessages && getPinnedMessages()
  }, [isOpenMessages])

  useEffect(() => {
    if (total === 1) {
      setCountMessages(`${total} ${lang('inchat-count-pinned-message')}`)
      return
    } else if (total > 1) {
      setCountMessages(`${total} ${lang('inchat-count-pinned-messages')}`)
      return
    } else {
      setCountMessages('')
      setIsOpenMessages(false)
    }
  } , [total])

  const removePinnedMessage = async (messageId) => {
    try {
      await apiInchat.pinRemove({ conversationId, messageId })
      getPinnedMessages()
    } catch (error) {
      toastMessage(lang('inchat_error_remove_pinned'), 'error')
    }
  }

  const getPinnedMessages = async () => {
    try {
      dispatch(inchatActions.getPinnedMessages(conversationId))
    } catch (error) {
      toastMessage(lang('inchat_error_get_pinned'), 'error')
    }
  }

  if (!countMessages) return null

  return (
    <div className='pinned-messages'>
      <div className='button-text-wrapper' onClick={onToggleIsOpenMessages} title={lang('inchat_show_pinned')}>
        <img src={getStaticImage('/icons/orange-brand/icon-menu-pin.svg')} alt='pin' />
        <span className='button-text'>{countMessages}</span>
      </div>
      { isOpenMessages ?
        <div className='messages-container'>
          <div className='title-wrapper'>
            <span className='pinned-title'>{lang('inchat_title_pinned_messages')}</span>
            <span className='pinned-close' onClick={onToggleIsOpenMessages} title={lang('inchat_hide_pinned')}>
              <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='close' />
            </span>
          </div>
          <div className='messages-inner'>
            {
              messages.map((message, index) =>
                <div key={`id-${index}`} className='message-wrapper'>
                  <span className='remove-pinned-message' onClick={() => removePinnedMessage(message._id)} title={lang('inchat_remove_pinned')}>
                    <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='close' />
                  </span>
                  <Message
                    key={index}
                    message={message}
                    showOptions={false}
                    showReactions={false}
                  />
                  <span className='message-time'>{getFormatedDate({ isoString: message.sentAt, withTime: true, withYear: true })}</span>
                </div>
              )
            }
          </div>
        </div>
        : null
      }
    </div>
  )
}

export default PinnedMessages